import Vue from 'vue'
import { getCouponCode } from '../../utils/coupon.js'

import { baseData } from '../../utils/accountHelper'
import { calculateCoupon } from '../../utils/detailHelper'
export default new Vue({
	created() {
		getCouponCode.then(coupon => {
			if (coupon && !coupon.isCouponInvalid) {
				this.coupon = coupon
			} else {
				location.replace('/s/pricing')
			}
		})
	},
	computed: {
		planData() {
			return (
				this.currentVersion && {
					...baseData[this.currentVersion].year,
					plan: baseData[this.currentVersion].plan,
				}
			)
		},
	},
	methods: {
		getPrice(version) {
			const yearData = baseData[version].year
			return calculateCoupon(this.coupon, yearData) || Number(yearData.total)
		},
	},
	data() {
		return {
			coupon: null,
			currentVersion: '',
		}
	},
})
